import React, { useMemo } from 'react';
import { useState, useEffect } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectInfoUser, selectTranslations } from '../App/slice/selectors';
import { LIST_TICKET } from '.';
import { useSearchParams } from 'utils/hooks/useSearchParams';

const SwitchTypeTicket = ({
  isShow,
  onChangeTicket,
  valueTicket,
  isDefault = false,
}: {
  isShow: boolean;
  onChangeTicket: (value?: number) => void;
  valueTicket: number;
  isDefault?: boolean;
}) => {
  const { getUrlParam, insertUrlParam } = useSearchParams();
  const userInfo = useSelector(selectInfoUser);

  const [isMobile, setIsMobile] = useState(false);
  const translations = useSelector(selectTranslations);

  // Handle responsive behavior
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1200);
    };

    // Check initially
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);

    // Clean up
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Create menu items for dropdown
  const menuItems = Object.keys(LIST_TICKET).map((ticketKey, index) => ({
    key: index,
    label: (
      <div
        style={
          valueTicket === Number(ticketKey)
            ? {
                backgroundColor: '#dfdfdf',
                padding: '2px 5px',
                borderRadius: '5px',
              }
            : { padding: '2px 5px' }
        }
      >
        {translations?.[LIST_TICKET?.[ticketKey]] || ''}
      </div>
    ),
    onClick: () => onChangeTicket(Number(ticketKey)),
  }));

  const menu = <Menu items={menuItems} />;

  useEffect(() => {
    if (!!userInfo) {
      const ticketTypeSession = sessionStorage.getItem('ticketType');
      const ticketTypeParam = getUrlParam('ticketType');

      if (!isDefault) {
        if (!!ticketTypeSession) {
          onChangeTicket(Number(ticketTypeSession));
        } else if (!!ticketTypeParam) {
          sessionStorage.setItem('ticketType', ticketTypeParam);
          onChangeTicket(Number(ticketTypeParam));
        } else {
          sessionStorage.setItem('ticketType', '0');
        }
      }
    }
  }, [userInfo]);

  const onChange = () => {
    const ticketType = sessionStorage.getItem('ticketType');
    if (!ticketType) {
      sessionStorage.setItem('ticketType', '1');
      onChangeTicket(1);
    } else {
      onChangeTicket();
    }
  };

  if (!isShow) return null;

  return (
    <div>
      {isMobile ? (
        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
          <StyledButtonSwitch>
            <svg
              fill="#000000"
              width="20px"
              height="20px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6,23H18a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H15a1,1,0,0,0-1,1,2,2,0,0,1-4,0A1,1,0,0,0,9,1H6A3,3,0,0,0,3,4V20A3,3,0,0,0,6,23ZM5,10h.882a1,1,0,0,0,0-2H5V4A1,1,0,0,1,6,3H8.126a4,4,0,0,0,7.748,0H18a1,1,0,0,1,1,1V8h-.882a1,1,0,0,0,0,2H19V20a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1ZM7.706,9a1,1,0,0,1,1-1h1.882a1,1,0,1,1,0,2H8.706A1,1,0,0,1,7.706,9Zm4.706,0a1,1,0,0,1,1-1h1.882a1,1,0,0,1,0,2H13.412A1,1,0,0,1,12.412,9Z" />
            </svg>
          </StyledButtonSwitch>
        </Dropdown>
      ) : (
        <StyledButtonSwitch onClick={() => onChange()}>
          {/* TODO: Đổi logic hiển thị */}
          {translations
            ? translations?.[LIST_TICKET?.[valueTicket === 0 ? 1 : 0]]
            : ''}
        </StyledButtonSwitch>
      )}
    </div>
  );
};

export const StyledButtonSwitch = styled(Button)`
  box-shadow: none !important;
  height: 45px;
  width: 166px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  margin-left: 20px;
  color: white;
  padding: 0;
  &:focus,
  &:active,
  &:hover {
    border: 1px solid #d9d9d9;
    box-shadow: none !important;
    color: white;
  }

  &:hover {
    opacity: 0.8;
  }

  &::after {
    content: none !important;
  }

  @media (min-width: 1200px) {
    background-image: linear-gradient(to right, #f06f24, #f8b117);
    &:focus,
    &:active,
    &:hover {
      background-image: linear-gradient(to right, #f06f24, #f8b117);
    }
  }

  @media (max-width: 1200px) {
    height: 41px;
    width: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0px;
  }
`;

export default SwitchTypeTicket;
